
export default {
  routeImporter: {
    'loadRouteFile': 'Importar archivo',
    'failedToLoadFile': 'No se ha podido cargar el archivo seleccionado. Asegúrese de que el archivo no está dañado y está en uno de los formatos aceptados',
    'acceptedImportTypes': 'Tipos de importaciones aceptadas',
    'dictDefaultMessage': 'Suelte el archivo a importar aquí o haga clic para seleccionar',
    'dictFallbackMessage': 'Navegador no compatible',
    'dictFileTooBig': 'Archivo muy grande',
    'dictInvalidFileType': 'Tipo de archivo no válido',
    'dictCancelUpload': 'Anular el envío',
    'dictUploadCanceled': 'envío anulado',
    'dictRemoveFile': 'Eliminar el archivo'
  }
}
